import { purify } from '@vfit/shared/themes';
import {
  TopContainer,
  BottomContainer,
  Wrapper,
  Container,
  AnchorArrowContainer,
  Title,
} from './redCard.style';
import { Button, ButtonSlide, ImageAtoms } from '@vfit/shared/atoms';
import { useDeviceType } from '@vfit/shared/hooks';
import { IRedCardProps } from '../redHubCard.models';
import { getVariantByActionStyle } from '@vfit/shared/data-access';

export const RedCard = ({ data, width, onClick, id }: IRedCardProps) => {
  const {
    backgroundColor,
    backgroundGradient,
    anchorDescription,
    anchorDescriptionMobile,
    anchorDescriptionTablet,
    actionDescription,
    actionDescriptionMobile,
    actionDescriptionTablet,
    mode,
    anchorMode,
    actionMode,
    backgroundImage,
  } = data;
  const [
    pAnchorDescription,
    pActionDescription,
    pAnchorDescriptionMobile,
    pAnchorDescriptionTablet,
    pActionDescriptionMobile,
    pActionDescriptionTablet,
  ] = purify([
    anchorDescription,
    actionDescription,
    anchorDescriptionMobile,
    anchorDescriptionTablet,
    actionDescriptionMobile,
    actionDescriptionTablet,
  ]);
  const { isMobile, isTablet, isDesktop } = useDeviceType();

  const pickDescription = ({
    mobile,
    tablet,
    desktop,
    isMobile,
    isTablet,
    isDesktop,
  }: {
    mobile?: string;
    tablet?: string;
    desktop?: string;
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
  }) => {
    let value = '';
    if (isMobile) value = mobile ?? '';
    else if (isTablet) value = tablet ?? '';
    else if (isDesktop) value = desktop ?? '';
    if (!value || value.trim() === '') {
      if (isMobile) value = tablet || desktop || '';
      else if (isTablet) value = desktop || '';
      else value = desktop || '';
    }

    return value.trim();
  };

  const html =
    mode === 'anchor'
      ? pickDescription({
          mobile: pAnchorDescriptionMobile,
          tablet: pAnchorDescriptionTablet,
          desktop: pAnchorDescription,
          isMobile,
          isTablet,
          isDesktop,
        })
      : pickDescription({
          mobile: pActionDescriptionMobile,
          tablet: pActionDescriptionTablet,
          desktop: pActionDescription,
          isMobile,
          isTablet,
          isDesktop,
        });

  const handleAnchorScroll = () => {
    const elementToScrollTo = document.getElementById(data.anchorMode.href.concat('_container'));
    if (elementToScrollTo) elementToScrollTo.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Wrapper isMobileOrTablet={isMobile || isTablet}>
      <div className="image-container">
        <ImageAtoms nameCard="bg-red-card" image={backgroundImage} />
      </div>
      <Container
        backgroundColor={backgroundColor}
        backgroundGradient={backgroundGradient}
        width={width}
        id={`${id}-${backgroundGradient}`}
      >
        <TopContainer>
          {pAnchorDescription || pActionDescription ? (
            <div
              dangerouslySetInnerHTML={{
                __html: html,
              }}
            />
          ) : null}
        </TopContainer>
        <BottomContainer>
          {mode === 'anchor' && anchorMode && (
            <div>
              <Title>{anchorMode.title}</Title>
              <AnchorArrowContainer>
                <ButtonSlide onClick={handleAnchorScroll} rotation={90} small smallSize={45} />
              </AnchorArrowContainer>
            </div>
          )}
          {mode === 'action' && actionMode && (
            <div>
              <Button variant={getVariantByActionStyle(actionMode.style)} onClick={onClick}>
                {actionMode?.title}
              </Button>
            </div>
          )}
        </BottomContainer>
      </Container>
    </Wrapper>
  );
};

